export const careContent = [
  {
    heroTitle: "Professional Care Home Services",
    heroImg: "",
    altText: "",
  },
  {
    introTitle: "We're Expert Bathroom Renovators",
    introText: `
Whether you know what you're looking for or in need of inspiration, AquaHeat will guide you through the entire process from start to finish.`,
  },
  {
    contLeftTitle: "Full bathroom suite fit-outs",
    contLeftText: `Our new bathroom installations are completed to a high-standard and carried out by our highly-qualified bathroom installers `,
    leftImgUrl: `https://res.cloudinary.com/duwmjod0j/image/upload/c_scale,q_100,w_580/v1643100767/AquaHeat/new%20images/Boiler-Repair-1_bn44ze.webp`,
  },
  {
    contRightTitle: "Specialist Bathroom Design",
    contRightText: `Together we plan and implement your ideas so you get the bathroom of your dreams, within your budget and timescale. `,
    rightImgUrl: `https://res.cloudinary.com/duwmjod0j/image/upload/c_scale,q_100,w_580/v1643100767/AquaHeat/new%20images/Boiler-Repair-1_bn44ze.webp`,
  },
  {
    callToActionTitle: "For Bathrooms Call On 0113 467 0278",
    callToActionSubTitle: "Servicing Over 8000 homes and businesses",
    callToActionText: `We have a trained team of Gas Safe registered engineers and
              plumbers with a wide range of plumbing experience. Our plumbers
              are available for 24/7 call outs or for regular boiler maintenance
              work or new boiler installations.`,
  },
];
